import { useState, useContext, useEffect } from 'react'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import ReportIcon from '@/assets/report.svg'
import SupportForm from '@/components/Sidebar/SupportForm'
import { SidebarContext } from '@/contexts/SidebarContextProps'
import { toast } from 'sonner'

export default function ContactSupportDialog() {
    const [isOpen, setIsOpen] = useState(false)
    const [courseHasConversations, setCourseHasConversations] = useState(false)
    const { selectedCourse, selectedConversation, courses } = useContext(SidebarContext)

    const handleProceedClick = () => {
        const course = courses?.find((course) => course.name === selectedCourse)
        const conversationExists = course?.history?.some(
            (conversation) => conversation.conversation_id === selectedConversation,
        )
        setCourseHasConversations(!!conversationExists)

        if (!conversationExists) {
            toast.info('Please select a course and a conversation before proceeding.')
        } else {
            setIsOpen(true)
        }
    }

    const closeDialog = () => {
        setIsOpen(false)
    }

    return (
        <Dialog open={isOpen && courseHasConversations} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <button
                    onClick={handleProceedClick}
                    className="shrink-0 group flex items-center justify-center bg-[#da291c] shadow-[0px_4px_16px_rgba(0,0,0,0.08)] border border-[var(--code-block-border)] rounded-2xl text-white px-[13.375px] hover:px-4 transition-all duration-300 overflow-hidden h-[50.75px]"
                >
                    <img src={ReportIcon} alt="Report Chat" className="h-[1.5rem] w-[1.5rem] shrink-0" />
                    <span className="max-w-0 opacity-0 group-hover:max-w-[200px] group-hover:opacity-100 group-hover:ml-2 transition-all duration-300 whitespace-nowrap text-sm font-bold">
                        Report Chat
                    </span>
                </button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Contact Support</DialogTitle>
                    <DialogDescription asChild>
                        <SupportForm closeDialog={closeDialog} />
                    </DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    )
}
